var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PieChart',{attrs:{"hcTitle":_vm.apiData ? _vm.apiData.title : null,"hcSubtitle":_vm.apiData ? _vm.apiData.last_update : null,"hcData":_vm.apiData ? _vm.apiData.chart_series : []}})}
var staticRenderFns = []

export { render, staticRenderFns }